angular.module('picmonicng').directive('voteIcons', [
  'UserService',
  'VotesResource',
  function (UserService, VotesResource) {
    return {
      restrict: 'E',
      template:
        '<span class="vote-icons-wrapper pls-grey">' +
        '{{voteSum?voteSum:0}} ' +
        '<i class="material-icons md-14 pointer" ng-class="{\'pls-green\': vote.vote == 1}" ng-click="castVote(1)">thumb_up</i> ' +
        '<i class="material-icons md-14 pointer" ng-class="{\'pls-red\': vote.vote == -1}" ng-click="castVote(-1)">thumb_down</i>' +
        '</span>',
      scope: {
        vote: '<',
        voteSum: '<',
        category: '@',
        categoryId: '<',
      },
      controller: [
        '$scope',
        function ($scope) {
          $scope.castVote = function (vote) {
            if (UserService.user.user_id) {
              if ($scope.vote) {
                vote = $scope.vote.vote == vote ? 0 : vote;
                $scope.voteSum += vote - $scope.vote.vote;
                $scope.vote.vote = vote;
                VotesResource.update($scope.vote);
              } else {
                $scope.voteSum += vote;
                $scope.vote = VotesResource.save({
                  category: $scope.category,
                  category_id: $scope.categoryId,
                  vote: vote,
                });
              }
            }
          };
        },
      ],
    };
  },
]);
